import { Col, Row } from 'antd';
import React, { Component } from 'react';

interface ContentWrappProps {
  style?: React.CSSProperties;
  children?: React.ReactNode;
  isMobile?: boolean;
}

class _ContentWrapp extends Component<ContentWrappProps> {
  render() {
    const { children, style, isMobile = false } = this.props;
    return (
      <Row
        style={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          ...style,
        }}
      >
        <Col
          style={{
            flex: 1,
            maxWidth: '1200px',
            width: '100%',
            margin: '0 auto',
            padding: isMobile ? 0 : '0 16px',
            backgroundColor: isMobile ? '#fff' : undefined,
          }}
        >
          {children}
        </Col>
      </Row>
    );
  }
}

export const ContentWrapp = _ContentWrapp;
